import { atom, useAtom } from 'jotai';
import { atomWithImmer } from 'jotai/immer';
import { useUpdateAtom, useAtomValue, RESET } from 'jotai/utils';
export var defaultData = {
  loading: {
    billDetail: false,
    productInfo: false
  }
};
export var dataAtom = atomWithImmer(defaultData);
export var proxyDataAtom = atom(function (get) {
  return get(dataAtom);
}, function (get, set, action) {
  set(dataAtom, action === RESET ? defaultData : action);
});

// update-only atom
export function useDataAtomUpdate() {
  return useUpdateAtom(dataAtom);
}

// read-write atom
export function useDataAtom() {
  return useAtom(dataAtom);
}

// read-only atom
export function useDataAtomValues() {
  return useAtomValue(dataAtom);
}